import * as yup from "yup";

const FormSchemaValidations = yup.object().shape({

  prodType: yup
    .mixed()
    .required("Este campo es obligatorio"),
  /*productCode: yup
    .string()
    .required("Este campo es obligatorio"),*/
  productName: yup.string().required("Este campo es obligatorio"),

  price: yup.string().required("Este campo es obligatorio"),
  quantity: yup.string().required("Este campo es obligatorio"),
  
  unitOfMeasure: yup
  .mixed()
  .required("Este campo es obligatorio"),

  discount: yup.number()
    .typeError('El valor debe ser un número')
    .min(0, 'El valor debe ser mayor o igual a 0')
    .max(100, 'El valor debe ser menor o igual a 100')
});

export default FormSchemaValidations;
